/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SmartEmailingService {
    /**
     * Generate action offer leflets.
     * Generate action offer leflets for Smart Emailing.
     * @returns any Success
     * @throws ApiError
     */
    public static getActionOfferLeaflets({
        apiVersion = 1,
        date,
    }: {
        apiVersion?: number,
        date?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/smartEmailing/action-offer-leaflets.json',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'date': date,
            },
            errors: {
                400: `Validation error.`,
            },
        });
    }
    /**
     * Serve background image for action offer.
     * Serve background image for action offer.
     * @returns binary Success
     * @throws ApiError
     */
    public static getActionOfferBackground({
        houseNumber,
        offerId,
        apiVersion = 1,
    }: {
        houseNumber: number,
        offerId: string,
        apiVersion?: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/smartEmailing/houses/{houseNumber}/actionOffers/{offerId}/background',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
                'offerId': offerId,
            },
            errors: {
                400: `Validation error.`,
            },
        });
    }
    /**
     * Generate restaurant menu.
     * Generate restaurant menu for Smart Emailing.
     * @returns any Success
     * @throws ApiError
     */
    public static getRestaurantMenu({
        apiVersion = 1,
        date,
    }: {
        apiVersion?: number,
        date?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/smartEmailing/restaurant-menu.json',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'date': date,
            },
            errors: {
                400: `Validation error.`,
            },
        });
    }
}
